module.exports = __webpack_public_path__ + "img/konfigurasi_tarif.a18ab935.svg";